import { useEffect, useState } from 'react';
import { findTeacherById } from '../../../firebase';
import ConnectModal from '../../util/ConnectModal';
import { useParams } from 'react-router-dom';

export default function ProfileDetails({ match }) {
    const {id} = useParams();
    const [info, setInfo] = useState();
    const [loading, setLoading] = useState(false);
    const [modalDetails, setModalDetails] = useState({
        id: "",
        type: "",
        typeId: ""
    })

    useEffect(() => {
        setLoading(true);
        findTeacherById(id).then(res => {
            setLoading(false);
            setInfo(res);
        }).catch(e => {
            setLoading(false);
        })
    }, [id]);

    return (
        <main id="main">
            <ConnectModal modalDetails={modalDetails}/>
            <section id="portfolio-details" className="portfolio-details text-start">
                {info && <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-4">
                            <div className="portfolio-details-slider">
                                <div className="text-center">
                                    <img src={info.pic} alt="add" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-5 col-sm-5">
                                            <span>Profile Details</span>
                                        </div>
                                        <div className="col-7 col-sm-7 text-end">
                                            <button className="btn btn-warning " 
                                            data-bs-toggle="modal" data-bs-target="#connectModal"
                                            onClick={() => setModalDetails({
                                                id: id,
                                                typeId: id,
                                                type: "Teacher"
                                            })}>Connect</button>
                                        </div>
                                    </div></h3>
                                <div className="row gy-3 pb-3">
                                    <div className="col-6 col-sm-6">
                                        <strong>Name</strong>: <i>{info.name}</i>
                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Experience</strong>: <i>{info.experience}</i>
                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Courses</strong>: <i>{info.courses}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Subject</strong>: <i>{info.subject}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Language</strong>: <i>{info.language}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Fees</strong>: <i>{info.fees}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Area</strong>: <i>{info.area}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>District</strong>: <i>{info.district}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>State</strong>: <i>{info.state}</i>

                                    </div>
                                    <div className="col-6 col-sm-6">
                                        <strong>Pin</strong>: <i>{info.pin}</i>

                                    </div>
                                    <div className="col-12 col-sm-12">
                                    <strong>Information:</strong> <p>{info.information}</p>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>}
                {loading && <div className="d-flex justify-content-center" style={{ color: "#eb5d1e" }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}
            </section>
        </main>

    );
}